import { Link } from 'react-router-dom';
import { stats } from '@/mocks/testimonials';

export default function AboutSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 lg:px-8 bg-background-100">
      <div className="w-full max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-center">
          <div className="relative">
            <span className="inline-flex items-center gap-2 px-3 py-1 bg-secondary-100 text-secondary-800 text-xs font-medium rounded-full mb-6">
              <i className="ri-information-line" />
              品牌介绍
            </span>
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20creative%20office%20workspace%20with%20team%20collaborating%20around%20large%20monitors%20showing%20video%20content%2C%20warm%20natural%20lighting%20from%20large%20windows%2C%20contemporary%20industrial%20design%20with%20plants%20and%20comfortable%20furniture%2C%20professional%20editorial%20photography%20with%20soft%20neutral%20tones&width=800&height=600&seq=about-brand&orientation=landscape"
              alt="91视频网站团队"
              className="w-full rounded-2xl object-cover aspect-[4/3]"
              loading="lazy"
            />
            <div className="absolute -bottom-4 -right-4 md:bottom-6 md:right-6 bg-primary-500 text-white p-4 md:p-6 rounded-xl shadow-xl">
              <p className="text-2xl md:text-3xl font-black">10+</p>
              <p className="text-xs md:text-sm text-primary-100">年行业深耕</p>
            </div>
          </div>

          <div>
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-5">
              致力于成为
              <br />
              最值得信赖的
              <br />
              <span className="text-primary-500">视频导航平台</span>
            </h2>
            <p className="text-foreground-500 text-base md:text-lg leading-relaxed mb-6">
              91视频网站创立于2014年，始终专注于为用户提供最优质的视频内容导航服务。我们汇聚了全网最丰富的视频资源，涵盖电影、电视剧、综艺、动漫、纪录片和音乐MV六大核心分类，让每一位用户都能在这里找到心仪的内容。
            </p>
            <p className="text-foreground-500 text-base md:text-lg leading-relaxed mb-8">
              秉承"让好内容触手可及"的理念，我们持续优化推荐算法，精选每日热门视频，提供专业影评和观看指南，打造一站式视频娱乐体验。
            </p>

            <div className="grid grid-cols-2 gap-4 md:gap-6 mb-8">
              {stats.map((stat) => (
                <div key={stat.label} className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70">
                  <p className="text-xl md:text-2xl font-black text-primary-600 mb-1">{stat.value}</p>
                  <p className="text-xs md:text-sm text-foreground-500">{stat.label}</p>
                </div>
              ))}
            </div>

            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-950 text-white font-medium rounded-xl hover:bg-foreground-800 transition-colors"
            >
              了解更多
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}